import React, {useEffect, useRef, useState} from 'react'
import InsertEmoticonIcon from '@material-ui/icons/InsertEmoticon'
import EmojiPicker from 'emoji-picker-react'
import './Style/Components.scss'
import {WSSelect} from '../../_metronic/helpers/components/WSSelect/WSSelect'
import {toAbsoluteUrl, countWords} from '../../_metronic/helpers'
import WebLink from '../pages/UserPages/MyTemplate/CreateScratch/WebLink'
import {useDispatch, useSelector} from 'react-redux'
import {last, uniq} from 'lodash'
import {getOurTemplateList} from '../pages/UserPages/MyTemplate/OurTemplates/OurTemplateSlice/OurTemplateSlice'
import {
  getAllTemplateWithoutPagination,
  getTemplateList,
  getTemplateListWithoutPagination,
} from '../pages/UserPages/MyTemplate/CreateScratch/CreateScratchSlices/CreateScratchSlices'
import {confirm} from 'react-confirm-box'
import {AuthenticateUser} from '../Utils/_helpers/RoleAndPermission'
import Select from 'react-select'
import {DEFAULT_REPLY_STOP_OUT_COUNT, processData, replaceMessageWith} from '../Utils/_helpers'
import {ENV} from '../Utils/_helpers/EnvHelper'
import {BulkMsgDraftData} from '../pages/UserPages/new-message/BulkMessageSlice/BulkMessageSlice'
import {GLOBAL_SETTINGS_TYPE} from '../Utils/Constant/ConstantForWebsite'
import {base64ToBlob, blobToFile} from '../Utils/file'
import WebLinkSecond from '../pages/UserPages/MyTemplate/CreateScratch/WebLinkSecond'
import {InputMessageContentRef} from './types/InputMessageContent'
import {InputMessageContent} from './InputMessageContent'
import { getDefaultOptOutUrlCount } from '../pages/UserPages/accounts/Overview/OverviewSlice/UserDetailsSlice'

const MessageBoxSecondV2 = ({
  setUserMessage,
  userMessage,
  selectedFile,
  itQuickMessage,
  quickSms,
  disableTextfield,
  setError,
  error,
  isInbox,
  isTemplate,
  showSelect,
  isRMSChat = false,
  onlyStop = false,
  isAlphaId = false,
  isDraft = false,
  containerStyle = {},
}: any) => {
  const dispatch = useDispatch()
  const inputRef = useRef<InputMessageContentRef | null>(null) // Updated ref type
  const pickerRef: any = useRef(null)
  const [popup, setPopup] = useState(false)
  const CustomFieldName: any = useSelector(
    (state: any) => state?.subscriberData?.FieldName?.data?.fields
  )
  const defaultDomain = `${ENV().REACT_APP_SHORTURL}`
  const [showMore, setShowMore] = useState(false)

  const conditionData =
    userMessage?.senderType == 'businessName' || userMessage?.senderType == 'customNumber'

  let optoutList = useSelector((state: any) => {
    const userGlobalSettings = state?.userDetails?.userDetails?.data?.user?.globalSetting
    let list = state?.optoutList?.optoutList?.data?.items || []

    if (quickSms) {
      const isDisableReplyByGlobalOption = userGlobalSettings?.includes(
        itQuickMessage
          ? GLOBAL_SETTINGS_TYPE.QUICK_SMS_REPLY_STOP_OUTPUT
          : GLOBAL_SETTINGS_TYPE.BULK_SMS_REPLY_STOP_OUTPUT
      )

      list = isDisableReplyByGlobalOption ? list : []
    }

    if (!quickSms) {
      const isDisableReplyByGlobalOption = userGlobalSettings?.includes(
        itQuickMessage
          ? GLOBAL_SETTINGS_TYPE.QUICK_MMS_REPLY_STOP_OUTPUT
          : GLOBAL_SETTINGS_TYPE.BULK_MMS_REPLY_STOP_OUTPUT
      )
      list = isDisableReplyByGlobalOption ? list : []
    }

    if (onlyStop) {
      return []
    }

    return list
  })
  const LandingPageList = useSelector((state: any) => state?.LandingPage?.landingPage?.data)
  const ShortLinkList = useSelector((state: any) => state?.ShortLink?.allTrackingLinks)
  const defaultOptOutUrlCount = useSelector(getDefaultOptOutUrlCount)

  // const templates: any = useSelector(getTemplateList)
  const templates: any = useSelector(getTemplateListWithoutPagination)
  const [showPicker, setShowPicker] = useState(false)
  const [webLinkDataToEdit, setWebLinkDataToEdit] = useState({longUrl: '', shortUrl: ''})

  const [options, setOptions] = useState({
    webLink: [
      {
        value: 'create',
        label: 'Create..',
        // label: (
        //   <button
        //     disabled={userMessage?.longUrl?.length >= 4}
        //     onClick={(e: any) => {
        //       e.preventDefault()
        //       setPopup(true)
        //       setWebLinkDataToEdit({longUrl: '', shortUrl: ''})
        //     }}
        //   >
        //     Create New
        //   </button>
        // ),
      },
    ],

    optOut: [{value: 'ReplyStop', label: `Reply 'Stop' to opt out`, isDisabled: conditionData}],
  })

  useEffect(() => {
    const handleOutsideClick = (e: any) => {
      if (pickerRef.current && !pickerRef.current.contains(e.target)) {
        setShowPicker(false)
      }
    }

    document.addEventListener('mousedown', handleOutsideClick)

    return () => {
      document.removeEventListener('mousedown', handleOutsideClick)
    }
  }, [])
  useEffect(() => {
    AuthenticateUser('templates-list') && dispatch(getAllTemplateWithoutPagination())
  }, [])
  const optOut = [
    // {
    //   value: '',
    //   label: `${
    //     userMessage?.replyStopToOptOut ? " Reply 'Stop' to opt-out" : 'STOP:{stoptxt.cc/}'
    //   }`,
    //   isDisabled: false,
    // },
    // {value: 'ReplyStop', label: `Reply 'Stop' to opt out`, isDisabled: conditionData},
  ]
  let data =
    CustomFieldName?.length > 0
      ? uniq(CustomFieldName as string[]) // Remove duplicates
          .map((key: string) => ({
            value: `{{[${key}]}}`,
            label: key,
          }))
      : []
  const LandingPages =
    LandingPageList?.length > 0
      ? LandingPageList?.map((key: any) => {
          return {
            value: `${key?._id}`,
            label: `${key?.campaignName}`,
          }
        })
      : []

  const CustomOptOutList =
    optoutList?.length > 0
      ? optoutList?.map((key: any) => {
          return {
            value: `${key?._id}`,
            label: `${key?.title}`,
          }
        })
      : []

  const Templates =
    templates?.length > 0
      ? templates
          ?.filter((key: any) => key?.type?.toUpperCase() == userMessage?.camp_type?.toUpperCase())
          ?.map((key: any) => {
            return {
              value: `${key?.name}`,
              label: `${key?.name}`,
            }
          })
      : []

  const handleChange = (e: any) => {
    if (e.label) {
      let errorData = {...error}

      delete errorData.messageSecond
      setError(errorData)
      let startSubString = userMessage?.messageSecond?.slice(0, inputRef.current?.selectionStart)
      let endSubString = userMessage?.messageSecond?.slice(inputRef.current?.selectionEnd)
      let content = startSubString + e.value + ' ' + endSubString

      setUserMessage({...userMessage, messageSecond: content})

      if (isDraft) {
        dispatch(BulkMsgDraftData({...userMessage, scheduledAtSecond: '', messageSecond: content}))
      }
      inputRef?.current?.focus()
    } else {
      let errorData = {...error}

      delete errorData.messageSecond
      e.target.value !== ''
        ? setError(errorData)
        : setError({...error, messageSecond: 'Message is required'})

      setUserMessage({
        ...userMessage,
        [e.target.name]: e.target.value,
      })
      if (isDraft) {
        dispatch(
          BulkMsgDraftData({...userMessage, scheduledAtSecond: '', [e.target.name]: e.target.value})
        )
      }
    }
  }

  const handleSelectShortUrl = (e: {label: string; shortUrl: string; upstreamUrl: string}) => {
    let startSubString = userMessage?.messageSecond?.slice(0, inputRef.current?.selectionStart)
    let endSubString = userMessage?.messageSecond?.slice(inputRef.current?.selectionEnd)

    if (e.shortUrl && e.upstreamUrl) {
      let errorData = {...error}

      delete errorData.messageSecond
      setError(errorData)
      let previousMessage = userMessage?.messageSecond
      let addAgain = startSubString + `${defaultDomain}/${e.shortUrl}` + ' ' + endSubString
      const regex = /short\.cellcast\.com\/\w+/

      const finalLongUrl = {
        longUrl: e.upstreamUrl,
        shortUrl: e.shortUrl,
      }

      const prevLongUrlSecond = userMessage?.longUrlSecond || []

      if (previousMessage?.match(regex) == null) {
        setUserMessage({
          ...userMessage,
          messageSecond: addAgain,
          longUrlSecond: [...prevLongUrlSecond, finalLongUrl],
        })
        if (isDraft) {
          dispatch(
            BulkMsgDraftData({
              ...userMessage,
              messageSecond: addAgain,
              longUrlSecond: [...prevLongUrlSecond, finalLongUrl],
            })
          )
        }
      } else {
        let content = previousMessage?.replace(
          new RegExp('\\b' + {defaultDomain} + '\\b'),
          e.shortUrl
        )
        setUserMessage({
          ...userMessage,
          messageSecond: content,
          longUrlSecond: [...prevLongUrlSecond, finalLongUrl],
        })
        if (isDraft) {
          dispatch(
            BulkMsgDraftData({
              ...userMessage,
              messageSecond: content,
              longUrlSecond: [...prevLongUrlSecond, finalLongUrl],
            })
          )
        }
      }
    }

    inputRef?.current?.focus()
  }

  // landing page
  const handleChangeLandingPage = (e: any) => {
    let startSubString = userMessage?.messageSecond?.slice(0, inputRef.current?.selectionStart)
    let endSubString = userMessage?.messageSecond?.slice(inputRef.current?.selectionEnd)

    if (e.value !== '') {
      let content = startSubString + `${ENV().REACT_APP_SHORTURL}/Lxxxxx` + ' ' + endSubString
      setUserMessage({...userMessage, messageSecond: content, landingPageIdSecond: e.value})
      if (isDraft) {
        dispatch(
          BulkMsgDraftData({
            ...userMessage,
            scheduledAtSecond: '',
            messageSecond: content,
            landingPageIdSsecond: e.value,
          })
        )
      }
      inputRef?.current?.focus()
    }
  }
  // weblink
  const handleWeblinkData = (e: any) => {
    if (e?.value == 'create') {
      setPopup(true)
      setWebLinkDataToEdit({longUrl: '', shortUrl: ''})
    } else {
      handleSelectShortUrl(e)
    }
  }

  // optout
  const handleOptout = (e: any) => {
    if (e?.value !== '') {
      if (userMessage?.senderType == 'businessName' || userMessage?.senderType == 'customNumber') {
        if (e.value !== 'ReplyStop') {
          setUserMessage({
            ...userMessage,
            replyStopToOptOutSecond: false,
            optoutSecond: true,
            optoutIdSecond: e.value,
            optoutLabelSecond: e.label,
          })
        }

        if (isDraft) {
          dispatch(
            BulkMsgDraftData({
              ...userMessage,
              scheduledAtSecond: '',
              replyStopToOptOutSecond: false,
              optoutSecond: true,
              optoutIdSecond: e.value,
              optoutLabelSecond: e.label,
            })
          )
        }
      } else {
        if (e.value == 'ReplyStop') {
          setUserMessage({
            ...userMessage,
            replyStopToOptOutSecond: true,
            optoutSecond: false,
            optoutIdSecond: '',
          })
          if (isDraft) {
            dispatch(
              BulkMsgDraftData({
                ...userMessage,
                scheduledAtSecond: '',
                optoutIdSecond: '',
                replyStopToOptOutSecond: true,
                optoutSecond: false,
              })
            )
          }
        } else {
          setUserMessage({
            ...userMessage,
            scheduledAtSecond: '',
            replyStopToOptOutSecond: false,
            optoutSecond: true,
            optoutIdSecond: e.value,
            optoutLabelSecond: e.label,
          })

          if (isDraft) {
            dispatch(
              BulkMsgDraftData({
                ...userMessage,
                scheduledAtSecond: '',
                replyStopToOptOutSecond: false,
                optoutSecond: true,
                optoutIdSecond: e.value,
                optoutLabelSecond: e.label,
              })
            )
          }
        }
      }
    } else {
      if (
        e.value == 'ReplyStop' &&
        userMessage?.senderType !== 'businessName' &&
        userMessage?.senderType !== 'customNumber'
      ) {
        setUserMessage({
          ...userMessage,
          replyStopToOptOutSecond: true,
          optoutSecond: false,
          optoutIdSecond: '',
        })

        if (isDraft) {
          dispatch(
            BulkMsgDraftData({
              ...userMessage,
              scheduledAtSecond: '',
              replyStopToOptOutSecond: true,
              optoutSecond: false,
              optoutIdSecond: '',
            })
          )
        }
      } else {
        setUserMessage({
          ...userMessage,
          replyStopToOptOutSecond: false,
          optoutSecond: true,
          optoutIdSecond: e.value,
          optoutLabelSecond: e.label,
        })
        if (isDraft) {
          dispatch(
            BulkMsgDraftData({
              ...userMessage,
              scheduledAtSecond: '',
              replyStopToOptOutSecond: false,
              optoutSecond: true,
              optoutIdSecond: e.value,
              optoutLabelSecond: e.label,
            })
          )
        }
      }
    }
  }

  // emoji
  const onEmojiClick = (event: any) => {
    let startSubString = userMessage?.messageSecond?.slice(0, inputRef.current?.selectionStart)
    let endSubString = userMessage?.messageSecond?.slice(inputRef.current?.selectionEnd)
    let content = startSubString + event.emoji + endSubString
    setUserMessage({...userMessage, messageSecond: content})

    if (isDraft) {
      dispatch(
        BulkMsgDraftData({
          ...userMessage,
          scheduledAtSecond: '',
          messageSecond: content,
        })
      )
    }
    setShowPicker(false)
    inputRef?.current?.focus()
  }
  const optionsWithLabelChange: any = {
    closeOnOverlayClick: false,
    labels: {
      confirmable: 'Yes',
      cancellable: 'No',
    },
  }

  const containsEmoji = (str: string) => {
    const unicodeRegex = /[^\u0000-\u007F]/ // Matches non-ASCII characters (Unicode)
    const emojiRegex = /(\p{Emoji_Presentation}|\p{Emoji}\uFE0F|\p{Extended_Pictographic})/u // Matches emojis
    return unicodeRegex.test(str) || emojiRegex.test(str)
  }

  // template
  const handleTemplate = async (event: any) => {
    const confirmation = await confirm(
      `Are you sure you want to use this ${event?.value} template`,
      optionsWithLabelChange
    )
    if (confirmation) {
      if (event?.value !== '') {
        if (userMessage?.camp_type == 'sms') {
          let startSubString = userMessage?.messageSecond?.slice(
            0,
            inputRef.current?.selectionStart
          )
          let endSubString = userMessage?.messageSecond?.slice(inputRef.current?.selectionEnd)
          let data = templates?.find((key: any) => key?.name === event?.value)
          if (data && data.longUrl && Array.isArray(data.longUrl)) {
            let longUrl = [...data.longUrl]
            let filteredLongUrl = longUrl.filter((item: any) => typeof item !== 'string')
            data = {...data, longUrl: filteredLongUrl}
          }

          // replace all optout message
          const messageSecond = replaceMessageWith(data?.message, '')
          let newPayload = {
            ...userMessage,
            messageSecond,
            longUrlSecond: data?.longUrl ?? undefined,
          }

          if (data?.optout && data.optout === true && data?.optoutId && data.optoutId !== '') {
            const optOutData = optoutList.find((el: any) => el._id === data.optoutId)
            if (optOutData) {
              newPayload.optoutLabelSecond = optOutData.title
            }

            newPayload.optoutSecond = data.optout
            newPayload.optoutIdSecond = data.optoutId
            newPayload.replyStopToOptOutSecond = false
          } else {
            newPayload.optoutSecond = false
            newPayload.optoutIdSecond = ''

            if (optoutList.length > 0) {
              newPayload.replyStopToOptOutSecond = true
            }
          }

          if (
            data?.landingPage &&
            data.landingPage === true &&
            data?.landingPageId &&
            data.landingPageId !== ''
          ) {
            newPayload.landingPageSecond = data.landingPage
            newPayload.landingPageIdSecond = data.landingPageId
          }

          setUserMessage(newPayload)
          if (isDraft) {
            dispatch(BulkMsgDraftData({...newPayload, scheduledAtSecond: ''}))
          }
          inputRef?.current?.focus()
        } else {
          let startSubString = userMessage?.messageSecond?.slice(
            0,
            inputRef.current?.selectionStart
          )
          let endSubString = userMessage?.messageSecond?.slice(inputRef.current?.selectionEnd)
          let messageData = replaceMessageWith(
            templates?.find((key: any) => key?.name === event?.value)?.messageSecond,
            ''
          )
          let data = templates?.find((key: any) => key?.name === event?.value)
          if (data && data.longUrl && Array.isArray(data.longUrl)) {
            let longUrl = [...data.longUrl]
            let filteredLongUrl = longUrl.filter((item: any) => typeof item !== 'string')
            data = {...data, longUrl: filteredLongUrl}
          }

          if (data?.media !== '') {
            let newPayload = {
              ...userMessage,
              message: messageData,
              media: data?.media,
              mediaType: data?.mediaType,
              urlData: {
                fileName: `${Date.now()}.jpg`,
                filetype: data?.mediaType,
                mediaType: data?.mediaType,
                url: data?.media,
              },
              subject: data?.subjectTitle,
              longUrl: data?.longUrl ?? undefined,
            }

            if (data?.base64media) {
              const fileName = data?.media.split('/').pop()
              const blob = base64ToBlob(data?.base64media, data?.mediaType)
              const file = blobToFile(blob, fileName)
              newPayload.media = file
            }

            if (data?.optout && data.optout === true && data?.optoutId && data.optoutId !== '') {
              const optOutData = optoutList.find((el: any) => el._id === data.optoutId)
              if (optOutData) {
                newPayload.optoutLabel = optOutData.title
              }

              newPayload.optout = data.optout
              newPayload.optoutId = data.optoutId
              newPayload.replyStopToOptOut = false
            } else {
              newPayload.optout = false
              newPayload.optoutId = ''

              if (optoutList.length > 0) {
                newPayload.replyStopToOptOut = true
              }
            }

            if (
              data?.landingPage &&
              data.landingPage === true &&
              data?.landingPageId &&
              data.landingPageId !== ''
            ) {
              newPayload.landingPage = data.landingPage
              newPayload.landingPageId = data.landingPageId
            }

            setUserMessage(newPayload)
            if (isDraft) {
              dispatch(BulkMsgDraftData({...newPayload, scheduledAtSecond: ''}))
            }
          } else {
            let newPayload = {
              ...userMessage,
              messageSecond: messageData,
              gif: data?.gif,
              mediaType: data?.mediaType,
              subject: data?.subjectTitle,
              longUrl: data?.longUrl ?? undefined,
            }
            if (data?.optout && data.optout === true && data?.optoutId && data.optoutId !== '') {
              const optOutData = optoutList.find((el: any) => el._id === data.optoutId)
              if (optOutData) {
                newPayload.optoutLabelSecond = optOutData.title
              }

              newPayload.optoutSecond = data.optout
              newPayload.optoutIdSecond = data.optoutId
              newPayload.replyStopToOptOutSecond = false
            } else {
              newPayload.optoutSecond = false
              newPayload.optoutIdSecond = ''
              if (optoutList.length > 0) {
                newPayload.replyStopToOptOutSecond = true
              }
            }

            if (
              data?.landingPage &&
              data.landingPage === true &&
              data?.landingPageId &&
              data.landingPageId !== ''
            ) {
              newPayload.landingPageSecond = data.landingPage
              newPayload.landingPageIdSecond = data.landingPageId
            }

            setUserMessage(newPayload)
            if (isDraft) {
              dispatch(BulkMsgDraftData({...newPayload, scheduledAtSecond: ''}))
            }
          }

          inputRef?.current?.focus()
        }
      }
    }
  }

  const optoutCount = userMessage?.optoutSecond === true ? defaultOptOutUrlCount : 0
  const replyStopToOptOutCount = userMessage?.replyStopToOptOutSecond === true ? DEFAULT_REPLY_STOP_OUT_COUNT : 0
  const webLinkOptions = userMessage?.longUrlSecond
    ? userMessage?.longUrlSecond?.map((key: any) => ({
        value: key?.shortUrl,
        label: key?.shortUrl,
      }))
    : []

  const shortLinkOptions = ShortLinkList?.map((key: any) => ({
    shortUrl: key?.shortUrl,
    upstreamUrl: key?.upstreamUrl,
    label: `${last(key?.shortUrl.split('/'))} (${key?.upstreamUrl})`,
  }))

  let textMessage = userMessage?.messageSecond
  let shortUrlCount = 0

  if (userMessage?.longUrlSecond?.length > 0) {
    const uniqueUrl = Array.from(new Map(userMessage.longUrlSecond.map((item: any) => [item.shortUrl, item])).values())

    for (let index = 0; index < uniqueUrl.length; index++) {
      const element: any = uniqueUrl[index];
      let tempShortUrl = `${defaultDomain}/${element.shortUrl}`

      if (textMessage.split(tempShortUrl).length - 1) {
        shortUrlCount += (textMessage.split(tempShortUrl).length - 1) * 6
      }
    }
  }

    const extraMessageCount = replyStopToOptOutCount + optoutCount + shortUrlCount
    const messageCount = processData(textMessage ?? '', extraMessageCount, isAlphaId)

  return (
    <div style={{...containerStyle}}>
      <WebLinkSecond
        data={webLinkDataToEdit}
        inputRef={inputRef}
        show={popup}
        handleClose={() => setPopup(false)}
        setBulkMessageData={setUserMessage}
        bulkMessageData={userMessage}
      />
      <div>
        <div className='mt-0 mb-7 col-12 message-wrapbox create-scratch-sms'>
          <label className='form-label'>Message {userMessage?.abTest ? '(B)' : null}</label>
          <div className='message-row row p-1 py-0 px-6 gy-0 gx-0 d-flex'>
            <div className='message-col  border-right-1'>
              <div className='selectbox' data-testid='ddCustomField2'>
                <img
                  className='imgpos'
                  src={toAbsoluteUrl('/media/mobile/Custom-field.svg')}
                  alt='img'
                  data-testid='iconCustomField2'
                />
                <Select
                  isSearchable={false}
                  value={{value: '', label: 'Custom Field'}}
                  onChange={(e: any) => {
                    handleChange(e)
                  }}
                  options={[...data]}
                  name='messageSecond'
                  className={`common-select`}
                  placeholder='Custom Field'
                />
              </div>
            </div>
            {showSelect?.includes('template') && (
              <div className='message-col border-right-1'>
                <div className='selectbox' data-testId='ddTemplates2'>
                  <img
                    className='imgpos'
                    src={toAbsoluteUrl('/media/mobile/web-link.svg')}
                    alt='img'
                    data-testid='iconTemplate2'
                  />
                  <Select
                    isSearchable={false}
                    value={{value: '', label: 'Template'}}
                    onChange={(e: any) => {
                      handleTemplate(e)
                    }}
                    options={[...Templates]}
                    name='messageSecond'
                    className={`common-select`}
                    placeholder='Templates'
                  />
                </div>
              </div>
            )}
            {showSelect?.includes('weblink') && (
              <div className='message-col border-right-1'>
                <div className='selectbox' data-testId='ddShortUrl2'>
                  <img
                    className='imgpos'
                    src={toAbsoluteUrl('/media/mobile/web-link.svg')}
                    alt='img'
                    data-testid='iconShortUrl2'
                  />
                  <Select
                    isSearchable={false}
                    value={{value: '', label: 'Short URL'}}
                    onChange={(e: any) => {
                      handleWeblinkData(e)
                    }}
                    options={[...options.webLink, ...shortLinkOptions]}
                    name='messageSecond'
                    className={`common-select `}
                    placeholder='Short URL'
                  />
                </div>
              </div>
            )}

            {showSelect?.includes('landingPage') && (
              <div className='message-col border-right-1'>
                <div className='selectbox selectname' data-testId='ddLandingPage2'>
                  <img
                    className='imgpos'
                    src={toAbsoluteUrl('/media/mobile/Landing-page.svg')}
                    alt='img'
                    data-testid='iconLandingPage2'
                  />
                  <Select
                    isSearchable={false}
                    onChange={(e: any) => {
                      handleChangeLandingPage(e)
                    }}
                    value={{value: '', label: 'Landing page'}}
                    options={[...LandingPages]}
                    name='messageSecond'
                    className={`common-select `}
                    placeholder='Custom-LandingPage'
                  />
                </div>
              </div>
            )}
            <div className='message-col last-col border-right-1 d-flex align-items-center justify-content-end'>
              <InsertEmoticonIcon onClick={() => setShowPicker((val) => !val)} />
            </div>
            {showPicker && (
              <div ref={pickerRef}>
                <EmojiPicker onEmojiClick={onEmojiClick} />
              </div>
            )}
          </div>

          <InputMessageContent
            isMessageSecond={true}
            ref={inputRef}
            disableTextfield={disableTextfield}
            maxLength={quickSms !== true ? 1000 : 1224 - (replyStopToOptOutCount + optoutCount)}
            onChange={handleChange}
            value={userMessage?.messageSecond}
            userMessage={userMessage}
            customOptOutList={CustomOptOutList}
            onChangeOptOut={handleOptout}
            showSelect={showSelect}
          />

          <div
            className='border border-1 rounded-1'
            style={{padding: '8px 12px', marginTop: '8px'}}
          >
            {isRMSChat ? (
              <span>Rich Messaging</span>
            ) : (
              <div className='d-flex justify-content-between align-items-center'>
                <label
                  style={{
                    color: '#5E6278',
                    fontWeight: 400,
                    fontSize: '12px',
                    letterSpacing: '0%',
                  }}
                >
                  {quickSms !== true
                    ? `1 MMS Credit${
                        countWords(userMessage?.messageSecond) > 1 ? 's' : ''
                      } ${countWords(userMessage?.messageSecond)}/1000`
                    : `${messageCount?.maxdata - messageCount?.length} / ${
                        messageCount?.maxdata
                      } total character${userMessage?.messageSecond?.length > 1 ? 's' : ''} used`}
                </label>
                {quickSms === true && (
                  <div style={{gap: '16px'}}>
                    <label
                      className='text-danger'
                      style={{
                        fontWeight: 600,
                        fontSize: '12px',
                        lineHeight: '14.4px',
                        letterSpacing: '0%',
                        textAlign: 'right',
                      }}
                    >
                      {messageCount?.length}{' '}
                      character remaining
                    </label>
                    <label
                      className='bg-primary px-2 py-1 text-white'
                      style={{
                        marginLeft: '16px',
                      }}
                    >
                      <b>
                        {' '}
                        {messageCount?.type} (
                        {messageCount?.credit} SMS
                        Parts)
                      </b>
                    </label>
                  </div>
                )}
              </div>
            )}
          </div>
          {containsEmoji(textMessage) && (
            <span>Special characters and emojis use multiple character spaces per message</span>
          )}
        </div>
      </div>
    </div>
  )
}

export default MessageBoxSecondV2
